"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRestService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class UserRestService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '/';
  }
  getCurrentUserInfo(options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', 'user/info', options, requestOptions);
    });
  }
  sendOneTimePasswordEmail(params, options = {}, requestOptions = {
    withoutErrorHandlers: true
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.POST, '', 'user/magic_link', Object.assign(Object.assign({}, options), {
        body: JSON.stringify({
          login: params.login,
          additional_data: params.additionalData,
          hoa_code: params.hoaCode,
          recaptcha_response: params.recaptcha_response
        })
      }), requestOptions);
    });
  }
  reSendOneTimePasswordEmail(params, options = {}, requestOptions = {
    withoutErrorHandlers: true
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.POST, '', 'users/re-send/login/' + params.re_send_code, Object.assign({}, options), requestOptions);
    });
  }
  sendRecoveryPassword(params, options = {}, requestOptions = {
    withoutErrorHandlers: true
  }) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.POST, '', 'users/password/forgot', Object.assign(Object.assign({}, options), {
        body: JSON.stringify({
          login: params.login,
          recaptcha_response: params.recaptcha_response
        })
      }), requestOptions);
    });
  }
}
exports.UserRestService = UserRestService;
const userRestService = new UserRestService();
exports.default = userRestService;